import { gql } from '@apollo/client'

export const PASSAGE_FIELDS = gql`
  fragment PassageFields on PassageType {
    id
    title
    startQuestion
    endQuestion
    content
    invertContentImages
    category
    subCategory
    reference
    watchPassageWalkthrough
  }
`

export const GET_LIST_PRACTICE_TEST = gql`
  query findAllPracticeTest($params: PracticeTestQueryInput = {}) {
    findAllPracticeTest(query: $params) {
      count
      items {
        id
        type
        title
        isLive
        membershipLevel
        order
        questionIds
      }
    }
  }
`

export const GET_ONE_PRACTICE_TEST = gql`
  ${PASSAGE_FIELDS}
  query findOnePracticeTest($params: String!) {
    findOnePracticeTest(id: $params) {
      id
      type
      title
      duration
      introAsHtml
      pageDescriptionAsHtml
      isLive
      membershipLevel
      order
      questionIds
      subject {
        id
        slug
        tabName
        platform {
          id
          slug
          title
        }
      }
      practiceTestCategory {
        id
      }
      passage {
        ...PassageFields
      }
      breaksSections {
        id
        questionIndex
        duration
      }
      testResult {
        DATScore
        id
        resultPercantage
        resultTextAsHtml
      }
      history {
        updatedAt
        updatedBy
      }
      university
      slug
      createdAt
      updatedAt
    }
    findQuestionByRelation(relationId: $params, relationName: pt) {
      id
      type
      title
      questionAsHtml
      questionCategory {
        id
      }
      answer {
        id
        isCorrect
        textAsHtml
        order
      }
    }
  }
`

export const CREATE_PRACTICE_TEST = gql`
  mutation createPracticeTest($params: CreatePracticeTestInput!) {
    createPracticeTest(createPracticeTestInput: $params) {
      id
    }
  }
`

export const UPDATE_PRACTICE_TEST = gql`
  mutation updatePracticeTest($params: UpdatePracticeTestInput!) {
    updatePracticeTest(updatePracticeTestInputFieldName: $params) {
      id
    }
  }
`

export const DELETE_PRACTICE_TEST = gql`
  mutation removePracticeTest($params: String!) {
    removePracticeTest(id: $params) {
      affected
    }
  }
`

export const SEARCH_PRACTICE_TEST = gql`
  query searchPracticeTest($searchString: String) {
    searchPracticeTest(searchString: $searchString) {
      count
      items {
        id
        title
      }
    }
  }
`

export const BULK_UPDATE_PRACTICE_TEST = gql`
  mutation bulkUpdatePracticeTest($params: [BulkUpdatePracticeTestInput!]!) {
    bulkUpdatePracticeTest(bulkUpdatePracticeTestInput: $params) {
      id
    }
  }
`

export const CHECK_IF_PRACTICE_TEST_USED_IN_ADDITIONAL_TESTS = gql`
  query checkIfPracticeTestUsedInAdditionalTests($id: String!) {
    checkIfPracticeTestUsedInAdditionalTests(id: $id)
  }
`

export const FIND_ALL_PRACTICE_TEST_RESULT = gql`
  query findAllPracticeTestResult($query: PracticeTestResultQueryInput!) {
    findAllPracticeTestResult(query: $query) {
      count
      items {
        id
        platform {
          id
          slug
        }
        history {
          updatedAt
          updatedBy
        }
        DATScore
        resultPercantage
        resultTextAsHtml
      }
    }
  }
`

export const BULK_UPDATE_PRACTICE_TEST_RESULTS = gql`
  mutation bulkUpdatePracticeTestResult($bulkUpdatePracticeTestResultInput: BulkUpdatePracticeTestResultInput!) {
    bulkUpdatePracticeTestResult(bulkUpdatePracticeTestResultInput: $bulkUpdatePracticeTestResultInput) {
      id
    }
  }
`

export const FIND_CURRENTLY_ACCESSING_COUNT = gql`
  query findCurrentlyAccessingCount($platformId: String!) {
    findCurrentlyAccessingCount(platformId: $platformId) {
      practiceTestId
      currentlyAccessing
    }
  }
`

export const FIND_IN_PERSON_MOCK_RESULTS = gql`
  query findInPersonMockResults($query: FindInPersonMockResultInput!) {
    findInPersonMockResults(query: $query) {
      ptId
      ptTitle
      university
      userCount
    }
  }
`

export const EXPORT_IN_PERSON_MOCK_RESULTS = gql`
  query exportInPersonMockStats($query: FindInPersonMockResultInput!) {
    exportInPersonMockStats(query: $query)
  }
`
